import { render } from "./ProductsTable.vue?vue&type=template&id=29be8e4a&ts=true"
import script from "./ProductsTable.vue?vue&type=script&lang=ts"
export * from "./ProductsTable.vue?vue&type=script&lang=ts"

const cssModules = {}
import style0 from "./ProductsTable.vue?vue&type=style&index=0&id=29be8e4a&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__